// extracted by mini-css-extract-plugin
module.exports = {"rateContent":"indicator_rateContent__1ZlRi"};